import { StyleSheet } from 'react-native-unistyles';

import { theme } from '@squire/ui';

export const styles = StyleSheet.create({
  container: {
    flex: 1,
    _web: {
      maxWidth: theme.breakpoints.tablet,
    },
  },
});
